import Crud from '../components/CreateDelete/Crud.vue'


let routes = {
    path: '/createdeletetenant',
    component: resolve => require(['../components/layout/AdminApp'], resolve),
    children: [
      {
        path: '/createdeletetenant',
        name: 'Logs criar deletar tenant',
        component: Crud
      },
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/createdeletetenant.js